/**
 * Marks a request that was aborted via HttpService.cancelRequests().
 *
 * A cancellation is not a failure: sync handlers release their claims and skip error reporting,
 * other consumers can settle their promises without surfacing an error to the user.
 */
export class RequestCancelledError extends Error {

  constructor(message: string = 'Request cancelled') {
    super(message);
    this.name = 'RequestCancelledError';
  }

}
